import HttpService from './commons/HttpService';

const CourtService = {
  save(court) {
    if (court.id && court.id > 0) {
      return this.update(court);
    }
    return this.create(court);
  },
  create(court) {
    return HttpService.post('/courts', court);
  },
  update(court) {
    return HttpService.put(`/courts/${court.id}`, court);
  },
  delete(court) {
    return HttpService.delete(`/courts/${court.id}`);
  },
  getById(id) {
    return HttpService.get(`/courts/${id}`);
  },
  findAllForCurrentUser() {
    return HttpService.get('/courts');
  },
};

export default CourtService;
